import { CustomerApplication, CustomerApplicationSubmission } from "@goodfill/domain-customer-application-types";
import { Fetcher, SafeResponse } from "../../fetcher";
import { CognitoIdToken } from "../users/authTypes";

export type ApiCreateCustomerApplicationRequest = CustomerApplication;

export const createCustomerApplication = async (
  fetcher: Fetcher,
  cognitoIdToken: CognitoIdToken,
  request: ApiCreateCustomerApplicationRequest,
): // Todo: replace `CustomerApplicationSubmission` with actual zod validation
Promise<SafeResponse<CustomerApplicationSubmission, "">> => {
  return fetcher({
    endpoint: "/customer-application/create",
    method: "POST",
    cognitoIdToken,
    data: request,
  });
};
